import { createReducer, on } from '@ngrx/store';
import { DeviceScheduledTasksApiActions } from './device-scheduled-tasks.actions';
import { adapter, initialState, selectScheduledTaskId } from './device-scheduled-tasks.state';

export const deviceScheduledTasksReducer = createReducer(
  initialState,
  on(DeviceScheduledTasksApiActions.scheduledTasksLoaded, (state, { scheduledTasks }) =>
    adapter.setAll(scheduledTasks, state)
  ),
  on(DeviceScheduledTasksApiActions.scheduledTaskDeleted, (state, { deviceTask }) =>
    adapter.removeOne(selectScheduledTaskId(deviceTask), state)
  ),
  on(DeviceScheduledTasksApiActions.scheduledTasksDeleted, (state) => adapter.removeAll(state))
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectDeviceScheduledTaskIds = selectIds;

export const selectDeviceScheduledTaskEntities = selectEntities;

export const selectAllDeviceScheduledTasks = selectAll;
